export enum DISPLAY_MODE {
  BROWSER = 'browser',
  PWA_ANDROID = 'pwa_android',
  PWA_IOS = 'pwa_ios',
  APP_ANDROID = 'app_android',
  APP_IOS = 'app_ios',
}
